export const DialogNames = {
  alert: 'alert',
  confirm: 'confirm',
  imageCrop: 'imageCrop',
  companyManage: 'company-manage',
  gallery: 'gallery',
  secureConfirm: 'secure-confirm',
  numericKeyboard: 'numeric-keyboard',
  colorPicker: 'color-picker',
  deliveryDialog: 'delivery-dialog',
  createItem: 'create-item',
  employeeDialog: 'employee-dialog',
  inviteContact: 'invite-contact',
  promptData: 'prompt-data',
  customerDialog: 'customer-dialog',
  noteDialog: 'note-dialog',
  workflowDialog: 'workflow-dialog',
  informationDialog: 'information-dialog',
  contactDialog: 'contact-dialog',
  contactPreview: 'contact-preview',
  fileUploaderDialog: 'file-uploader-dialog',
  ndaDialog: 'nda-dialog',
  companyNdasUpload: 'company-ndas-upload',
  companyNdasPreview: 'company-ndas-preview',
  createPlaceholder: 'create-placeholder',
  taskDialog: 'tasks-dialog',
  selectDealType: 'select-deal-type',
  closedDealStepper: 'closed-deal-stepper',
  closedDealEntryMethod: 'closed-deal-entry-method',
  currentDealEntryMethod: 'current-deal-entry-method',
  termSheetReview: 'term-sheet-review',
  benchmarkPublish: 'benchmark-publish',
  addContextDocDialog: 'add-context-doc-dialog',
  extractionOptIn: 'extraction-opt-in',
  extractionReview: 'extraction-review',
  scannedDocumentWarning: 'scanned-document-warning',
} as const;

export type DialogName = (typeof DialogNames)[keyof typeof DialogNames];
